import React from 'react';
import PrivateRoute from '../../routes/privateRoute';
import GroupManagement from './views/GroupManagement';

const UserManagement = React.lazy(() => import('./views/UserManagement'));

const userRoutes = {
    path: '/users',
    name: 'Users & Groups',
    component: UserManagement,
    icon: 'dripicons-user',
    permissions: [{name: ['User.ReadOnly']}, {name: ['User.FullControl']}],
    children: [
        {
            path: '/users',
            name: 'Users',
            component: UserManagement,
            show: true,
            route: PrivateRoute,
            permissions: [{name: ['User.ReadOnly']}, {name: ['User.FullControl']}],
        },
        {
            path: '/user-groups',
            name: 'Groups   ',
            component: GroupManagement,
            show: true,
            route: PrivateRoute,
            permissions: [{name: ['User.ReadOnly']}, {name: ['User.FullControl']}],
        },
    ],
};

export default userRoutes;
